module.exports = __webpack_public_path__ + "static/media/show-more.6f4406a0.svg";